// Commerce connector API is called in all our pes pages
export const ATG_COMMERCE_CONNECTOR_PATH = '/product/pdp/commerce-connector';

// Product-software is called in PDP pages for software products
export const ATG_PRODUCT_SOFTWARE_PATH = '/product/api/product-software';

// product card main and secondary API is used called in range ,category listing and comparision pages.
export const ATG_PRODUCT_CARD_ADDITION_PATH = '/product/api/productCard/addition';
export const ATG_PRODUCT_CARD_MAIN_PATH = '/product/api/productCard/main';

// My products is called in range and pdp and also in category and subcategory listing products
export const ATG_MY_PRODUCTS_REST_URL = '/product/my-products';

// Categories by business ID is called in all products when we select a particular business categiry
export const ATG_CATEGORIES_BUSINESS_ID = '/product/all-products/categories';

export const ATG_ANALYTICS_LOOKUPS = '/product/api/analytics/lookups';
